
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1617674936203",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "4263",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M76.775946 12.60487h312.222181c42.48269 0 76.775946 33.781416 76.775946 76.775946v317.340577c0 42.48269-34.293256 76.775946-76.775946 76.775946h-312.222181c-42.48269 0-76.775946-33.781416-76.775946-76.775946v-317.340577c0-42.48269 34.293256-76.775946 76.775946-76.775946z",
        "fill": "#FD4E45",
        "p-id": "4264"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M76.775946 550.036493h312.222181c42.48269 0 76.775946 33.781416 76.775946 76.775946v317.340577c0 42.48269-34.293256 76.775946-76.775946 76.775946h-312.222181c-42.48269 0-76.775946-33.781416-76.775946-76.775946v-317.340577c0-42.48269 34.293256-76.775946 76.775946-76.775946z",
        "fill": "#FF933D",
        "p-id": "4265"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M515.422518 231.160397l220.091046-220.091046c14.84335-14.84335 39.923492-14.84335 54.766841 0.51184l222.138404 222.138404c15.355189 15.355189 15.355189 39.923492 0.51184 54.766841l-220.091046 220.091046c-14.84335 14.84335-39.923492 14.84335-54.766841-0.51184l-222.138404-222.138404c-15.355189-14.84335-15.355189-39.923492-0.51184-54.766841z",
        "fill": "#12BC83",
        "p-id": "4266"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M608.065493 550.036493h312.222181c42.48269 0 76.775946 33.781416 76.775946 76.775946v317.340577c0 42.48269-34.293256 76.775946-76.775946 76.775946h-312.222181c-42.48269 0-76.775946-33.781416-76.775946-76.775946v-317.340577c0-42.48269 34.293256-76.775946 76.775946-76.775946z",
        "fill": "#2C97FE",
        "p-id": "4267"
      }
    }
  ]
})
    }
  